"use client";

import { ArrowRight } from "lucide-react";

import { useCheckout } from "@/lib/hooks/use-checkout";
import { Spinner } from "@/components/ui/spinner";

export function FinalCta() {
  const { loadingPlan, start } = useCheckout("landing_final_cta");

  return (
    <section className="relative overflow-hidden bg-[#0B1120] px-6 py-24 sm:py-32">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(900px 360px at 50% 0%, rgba(139, 92, 246, 0.18), transparent 70%)",
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(0deg, rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />

      <div className="relative mx-auto max-w-3xl text-center" data-reveal>
        <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-violet-300">
          One payment · forever access
        </p>
        <h2 className="mt-5 font-heading text-[36px] font-bold leading-[1.05] tracking-tight text-white sm:text-[52px]">
          Stop renting your funnel builder.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15px] leading-relaxed text-slate-400 sm:text-[17px]">
          £67 once. Every funnel you'll ever ship. Every update we'll ever
          ship. Locked in at the early-bird price.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <button
            onClick={() => start("lifetime")}
            disabled={loadingPlan !== null}
            className="group inline-flex h-12 items-center justify-center gap-2 rounded-full bg-white px-7 text-[14px] font-semibold text-slate-900 shadow-[0_10px_30px_-12px_rgba(255,255,255,0.4)] transition-transform hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loadingPlan === "lifetime" ? (
              <>
                <Spinner className="h-3.5 w-3.5" />
                Redirecting…
              </>
            ) : (
              <>
                Get Lifetime — £67
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </>
            )}
          </button>
          <a
            href="#pricing"
            className="text-[13px] font-medium text-slate-400 underline decoration-slate-700 underline-offset-4 transition-colors hover:text-white hover:decoration-slate-400"
          >
            See monthly plans
          </a>
        </div>

        <p className="mt-8 text-[12px] text-slate-500">
          30-day refund · no questions · no retention calls
        </p>
      </div>
    </section>
  );
}
